const GET_ASSIGNMENT_STAFF_TROUSER_LIST = "GET_ASSIGNMENT_STAFF_TROUSER_LIST"
const GET_ASSIGNMENT_STAFF_TROUSER_LIST_SUCCESS =
  "GET_ASSIGNMENT_STAFF_TROUSER_LIST_SUCCESS"
const GET_ASSIGNMENT_STAFF_JACKET_LIST = "GET_ASSIGNMENT_STAFF_JACKET_LIST"
const GET_ASSIGNMENT_STAFF_JACKET_LIST_SUCCESS =
  "GET_ASSIGNMENT_STAFF_JACKET_LIST_SUCCESS"
const GET_ASSIGNMENT_RTW_ORDER_LIST = "GET_ASSIGNMENT_RTW_ORDER_LIST"
const GET_ASSIGNMENT_RTW_ORDER_LIST_SUCCESS =
  "GET_ASSIGNMENT_RTW_ORDER_LIST_SUCCESS"
const GET_ASSIGNMENT_RTW_ORDER_SIZE_LIST = "GET_ASSIGNMENT_RTW_ORDER_SIZE_LIST"
const GET_ASSIGNMENT_RTW_ORDER_SIZE_LIST_SUCCESS =
  "GET_ASSIGNMENT_RTW_ORDER_SIZE_LIST_SUCCESS"
const GET_ASSIGNMENT_ORDER_LIST = "GET_ASSIGNMENT_ORDER_LIST"
const GET_ASSIGNMENT_ORDER_LIST_SUCCESS = "GET_ASSIGNMENT_ORDER_LIST_SUCCESS"
const GET_ASSIGNMENT_WEEK_LIST = "GET_ASSIGNMENT_WEEK_LIST"
const GET_ASSIGNMENT_WEEK_LIST_SUCCESS = "GET_ASSIGNMENT_WEEK_LIST_SUCCESS"
const PUT_ASSIGNMENT_RTW_ORDER = "PUT_ASSIGNMENT_RTW_ORDER"
const PUT_ASSIGNMENT_RTW_ORDER_SUCCESS = "PUT_ASSIGNMENT_RTW_ORDER_SUCCESS"
const PUT_ASSIGNMENT_ORDER = "PUT_ASSIGNMENT_ORDER"
const PUT_ASSIGNMENT_ORDER_SUCCESS = "PUT_ASSIGNMENT_ORDER_SUCCESS"
const DELETE_ASSIGNMENT_RTW_ORDER = "DELETE_ASSIGNMENT_RTW_ORDER"
const DELETE_ASSIGNMENT_RTW_ORDER_SUCCESS =
  "DELETE_ASSIGNMENT_RTW_ORDER_SUCCESS"
const DELETE_ASSIGNMENT_ORDER = "DELETE_ASSIGNMENT_ORDER"
const DELETE_ASSIGNMENT_ORDER_SUCCESS = "DELETE_ASSIGNMENT_ORDER_SUCCESS"
const PATCH_ASSIGNMENT_DATA = "PATCH_ASSIGNMENT_DATA"
const PATCH_ASSIGNMENT_DATA_SUCCESS = "PATCH_ASSIGNMENT_DATA_SUCCESS"
const PUT_ASSIGNMENT_ORDER_LOCAL_STATE = "PUT_ASSIGNMENT_ORDER_LOCAL_STATE"
const PUT_ASSIGNMENT_ORDER_LOCAL_STATE_SUCCESS =
  "PUT_ASSIGNMENT_ORDER_LOCAL_STATE_SUCCESS"
const PUT_ASSIGNMENT_RTW_ORDER_LOCAL_STATE =
  "PUT_ASSIGNMENT_RTW_ORDER_LOCAL_STATE"
const PUT_ASSIGNMENT_RTW_ORDER_LOCAL_STATE_SUCCESS =
  "PUT_ASSIGNMENT_RTW_ORDER_LOCAL_STATE_SUCCESS"

const AssignmentType = {
  GET_ASSIGNMENT_STAFF_TROUSER_LIST,
  GET_ASSIGNMENT_STAFF_TROUSER_LIST_SUCCESS,
  GET_ASSIGNMENT_STAFF_JACKET_LIST,
  GET_ASSIGNMENT_STAFF_JACKET_LIST_SUCCESS,
  GET_ASSIGNMENT_RTW_ORDER_LIST,
  GET_ASSIGNMENT_RTW_ORDER_LIST_SUCCESS,
  GET_ASSIGNMENT_RTW_ORDER_SIZE_LIST,
  GET_ASSIGNMENT_RTW_ORDER_SIZE_LIST_SUCCESS,
  GET_ASSIGNMENT_ORDER_LIST,
  GET_ASSIGNMENT_ORDER_LIST_SUCCESS,
  GET_ASSIGNMENT_WEEK_LIST,
  GET_ASSIGNMENT_WEEK_LIST_SUCCESS,
  PUT_ASSIGNMENT_RTW_ORDER,
  PUT_ASSIGNMENT_RTW_ORDER_SUCCESS,
  PUT_ASSIGNMENT_ORDER,
  PUT_ASSIGNMENT_ORDER_SUCCESS,
  DELETE_ASSIGNMENT_RTW_ORDER,
  DELETE_ASSIGNMENT_RTW_ORDER_SUCCESS,
  DELETE_ASSIGNMENT_ORDER,
  DELETE_ASSIGNMENT_ORDER_SUCCESS,
  PATCH_ASSIGNMENT_DATA,
  PATCH_ASSIGNMENT_DATA_SUCCESS,
  PUT_ASSIGNMENT_ORDER_LOCAL_STATE,
  PUT_ASSIGNMENT_ORDER_LOCAL_STATE_SUCCESS,
  PUT_ASSIGNMENT_RTW_ORDER_LOCAL_STATE,
  PUT_ASSIGNMENT_RTW_ORDER_LOCAL_STATE_SUCCESS,
}

export default AssignmentType
